import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IInforme } from '../models/typesInformes';
import { cartApi } from '../api/cartApi';

// Create async thunks to interact with the API
export const fetchCart = createAsyncThunk(
    'cart/fetchCart',
    async (_, { dispatch, getState }) => {
        // This will be handled by RTK Query, we just need to provide a way
        // for components to trigger the fetch through regular Redux actions
        return null;
    }
);

export const addInformeToCart = createAsyncThunk(
    'cart/addInformeToCart',
    async (informe: IInforme, { dispatch, getState, extra }) => {
        const cartItem = {
            id: informe._id || new Date().getTime().toString(),
            nombre: informe.descripcion || 'Informe',
            tipo: informe.tipo || '',
            data: informe
        };

        await dispatch(cartApi.endpoints.addItemToCart.initiate(cartItem));
        return informe;
    }
);

export const updateInformeInCart = createAsyncThunk(
    'cart/updateInformeInCart',
    async (informe: IInforme, { dispatch }) => {
        const cartItem = {
            id: informe._id || informe.id?.toString() || '',
            nombre: informe.descripcion || 'Informe',
            tipo: informe.tipo || '',
            data: informe
        };

        await dispatch(cartApi.endpoints.updateItemInCart.initiate({ informe: cartItem }));
        return informe;
    }
);

export const removeInformeFromCart = createAsyncThunk(
    'cart/removeInformeFromCart',
    async (informe: IInforme, { dispatch }) => {
        const informeId = informe._id || informe.id?.toString() || '';

        await dispatch(cartApi.endpoints.removeItemFromCart.initiate({ informeId }));
        return informe;
    }
);

export const clearCartThunk = createAsyncThunk(
    'cart/clearCartThunk',
    async (_, { dispatch, getState }) => {
        const state = getState() as any;
        const cartData = state.cartApi.queries['getCart(undefined)']?.data?.data;

        if (cartData && cartData.length > 0) {
            console.log('Clearing cart with items:', cartData);
            const itemIds = cartData.map((item: any) => item.uuid);
            await dispatch(cartApi.endpoints.clearCart.initiate({ itemIds }));
        }

        return null;
    }
);

export const cartSlice = createSlice({
    initialState: {
        informes: [] as IInforme[],
        loading: false,
        error: null as string | null,
    },
    name: 'cartSlice',
    reducers: {
        // These are kept for backward compatibility but they'll trigger API calls
        addInforme: (state, action: PayloadAction<IInforme>) => {
            // This will be a no-op, handled by the thunk
        },
        updateInforme: (state, action: PayloadAction<IInforme>) => {
            // This will be a no-op, handled by the thunk
        },
        removeInforme: (state, action: PayloadAction<IInforme>) => {
            // This will be a no-op, handled by the thunk
        },
        restoreInformes: (state) => {
            // This will be a no-op, handled by the thunk
        },
        clearCart: (state) => {
            // This will be a no-op, handled by the thunk
        },
        // New action to sync state with API response
        syncWithApi: (state, action: PayloadAction<IInforme[]>) => {
            state.informes = action.payload;
        }
    },
    // Handle the async thunk actions
    extraReducers: (builder) => {
        builder
            .addCase(fetchCart.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCart.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(fetchCart.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Error fetching cart';
            });
    }
});

export default cartSlice.reducer;

export const { addInforme, removeInforme, restoreInformes, updateInforme, clearCart, syncWithApi } = cartSlice.actions;